import * as React from 'react';
import { Link } from 'react-router-dom';

import './HomeStyle.scss';

class HomeUI extends React.Component<{}, {}> {

    public async componentDidMount() {
        document.title = "CFC | Home";
    }

    public render() {
        return (<div style={{ textAlign: 'center' }}>
            <h2>Select a link to a form</h2>
            <ul className="ulStyle">
                <li><Link to={'/uefadeclaration'}>UEFA Declaration Form</Link></li>
                <li><Link to={'/covid19declaration'}>Covid-19 Declaration Form</Link></li>
            </ul>
        </div>);
    }
}

export default HomeUI;